<template>
  <Col>
    <Hero
      title="Vue Finance - Features"
      minHeight="500px"
      backgroundColor="#2c3849"
      description="Providing you with all the tools you need to stay on top of your portfolio and make financial decisions confidently."
      ></Hero>
    <Row type="flex" justify="space-around" class="container">
      <Col style="max-width: 600px;">
        <div class="feature-item">
          <h1 id="account-aggregation"><Icon type="ios-ionic-outline"></Icon> Account Aggregation</h1>
          <h3>We integrate with over 14,000 financial institutions to connect Checking, Savings, Brokerage, and Retirement accounts, and more. Once connected we stay in sync with the balance and position of any external account.</h3>
          <GetStartedButton class="vertical-margin-8"></GetStartedButton>
        </div>

        <div class="feature-item">
          <h1 id="custom-assessments"><Icon type="ios-pie-outline"></Icon> Custom Assessments</h1>
          <h3>We give you the ablility to build your own dashboard using our Assessment Builder. You can create various types of dynamic charts, reports, and other visualizations to get the information and insights you care about the most.</h3>
          <GetStartedButton class="vertical-margin-8"></GetStartedButton>
        </div>

        <div class="feature-item">
          <Row type="flex">
            <NestedIcon></NestedIcon>
            <h1 id="nested-accounts">Nested Accounts</h1>
          </Row>
          
          <h3>We allow nested accounts in order to properly represent any assets you own through a separate entity. This is useful if you own real estate through an LLC/Trust or have a business with assets that are not personally owned.</h3>
          <GetStartedButton class="vertical-margin-8"></GetStartedButton>
        </div>

        <div class="feature-item">
          <h1 id="configurable-valuations"><Icon type="ios-gear-outline"></Icon> Configurable Valuations (Formulas)</h1>
          <h3>We're the only personal finance software that lets <strong>you</strong> decide how to value an asset. Use Formulas to define how to generate valuations for an account. You can even reference the value of another account in your formulas.</h3>
          <GetStartedButton class="vertical-margin-8"></GetStartedButton>
        </div>


        <div class="feature-item">
          <h1 id="integrations"><Icon type="ios-color-filter-outline"></Icon> Integrations</h1>
          <h3>In some cases, you'll want to pull a valuation of an asset from an external source. This is useful if you want to value real estate using Zillow, or a business using your accounting system. There is no need to duplicate any efforts to keep everything in sync.</h3>
          <GetStartedButton class="vertical-margin-8"></GetStartedButton>
        </div>

      </Col>
      <Col>
        <Affix :offset-top="84">
          <Card style="width: max-content;">
            <Row type="flex" justify="start">
              <Col>
                <a href="#" v-scroll-to="{el: '#account-aggregation', offset: -84}">
                  <p><Icon type="arrow-right-b"></Icon> Account Aggregation</p>
                </a>

                <a href="#" v-scroll-to="{el: '#custom-assessments', offset: -84}">
                  <p><Icon type="arrow-right-b"></Icon> Custom Assessments</p>
                </a>

                <a href="#" v-scroll-to="{el: '#nested-accounts', offset: -84}">
                  <p><Icon type="arrow-right-b"></Icon> Nested Accounts</p>
                </a>

                <a href="#" v-scroll-to="{el: '#configurable-valuations', offset: -84}">
                  <p><Icon type="arrow-right-b"></Icon> Configurable Valuations</p>
                </a>

                <a href="#" v-scroll-to="{el: '#integrations', offset: -84}">
                  <p><Icon type="arrow-right-b"></Icon> Integrations</p>
                </a>
              </Col>
            </Row>
          </Card>
        </Affix>
      </Col>
    </Row>
  </Col>
</template>
<script>
import Hero from './Hero';
import NestedIcon from './NestedIcon';
import GetStartedButton from './GetStartedButton';

export default {
  components: { NestedIcon, Hero, GetStartedButton },
};
</script>
<style lang="css" scoped>
.vertical-margin-8 { margin: 8px 0; }
.container {
  padding: 0 42px;
}

.feature-item {
  margin-bottom: 64px;
}

.ivu-icon {
  color: #39f;
}
</style>



// WEBPACK FOOTER //
// src/components/FeaturesPage.vue